"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var Signup_1 = require("../SignupModal/Signup");
var SignupContext_1 = require("../SignupModal/SignupContext");
var menu_1 = require("../../utils/shopify/menu");
var icon_1 = require("../../constants/img/icon");
var logo_1 = require("../../constants/img/logo");
var signup_modal_1 = require("../SignupModal/utils/signup-modal");
var Footer = function () {
    var _a = (0, hooks_1.useState)(null), links = _a[0], setLinks = _a[1];
    var excludedUrl = window.location.href.indexOf('/collections/menopause') > -1 ||
        window.location.href.includes('pages/write-a-review') ||
        window.location.href.includes('/tools/recurring/portal');
    var isDesktop = window.innerWidth >= 1025;
    var buttonImageUrl = isDesktop ? icon_1.GRADIENT_BUTTON_DESKTOP : icon_1.GRADIENT_BUTTON_MOBILE;
    var _b = (0, hooks_1.useState)(0), formStep = _b[0], setFormStep = _b[1];
    var _c = (0, hooks_1.useState)((0, signup_modal_1.shouldShowSignupModal)()), modalOpen = _c[0], setModalOpen = _c[1];
    var _d = (0, hooks_1.useState)((0, signup_modal_1.shouldShowMiniPopup)()), miniPopupOpen = _d[0], setMiniPopupOpen = _d[1];
    (0, hooks_1.useEffect)(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var menus;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, menu_1.getFooterMenus)()];
                    case 1:
                        menus = _a.sent();
                        setLinks(menus);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, []);
    var handleClickSubscribe = function () {
        setModalOpen(true);
    };
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)("footer", { class: "footer" },
            (0, preact_1.h)("div", { class: "footer-subscribe-socials-links" },
                (0, preact_1.h)("div", { class: "footer-subscribe-socials" },
                    (0, preact_1.h)("div", { class: "footer-subscribe" },
                        (0, preact_1.h)("p", { class: "footer-subscribe__header" }, "Keep in Touch"),
                        (0, preact_1.h)("p", { class: "footer-subscribe__body" },
                            "Join our list for exclusive access to ",
                            (0, preact_1.h)("br", null),
                            "discounts and product launches"),
                        !excludedUrl && ((0, preact_1.h)("button", { class: "footer-subscribe__cta", onClick: handleClickSubscribe },
                            (0, preact_1.h)("p", { class: "footer-subscribe__cta-text" }, "GET EXCLUSIVE OFFERS")))),
                    (0, preact_1.h)("div", { class: "footer-subscribe__socials" },
                        (0, preact_1.h)("a", { href: "https://www.tiktok.com/@opositiv?lang=en" },
                            (0, preact_1.h)("img", { src: logo_1.TIKTOK_LOGO, alt: "TikTok logo", class: "footer-subscribe__socials-image" })),
                        (0, preact_1.h)("a", { href: "https://www.instagram.com/opositiv/?hl=en" },
                            (0, preact_1.h)("img", { src: logo_1.INSTAGRAM_LOGO, alt: "Instagram logo", class: "footer-subscribe__socials-image" })))),
                (0, preact_1.h)("div", { class: "footer-links__container" },
                    (0, preact_1.h)("div", { class: "footer-links" },
                        (0, preact_1.h)("p", { class: "footer-links__header" }, "EXPLORE"),
                        (0, preact_1.h)("ul", { class: "footer-links__list" }, links &&
                            links.explore.items.map(function (item) { return ((0, preact_1.h)("li", { class: "footer-links__item", key: item.id },
                                (0, preact_1.h)("a", { class: "footer-links__link", href: item.url }, item.title))); }))),
                    (0, preact_1.h)("div", { class: "footer-links" },
                        (0, preact_1.h)("p", { class: "footer-links__header" }, "SUPPORT"),
                        (0, preact_1.h)("ul", { class: "footer-links__list" }, links &&
                            links.support.items.map(function (item) { return ((0, preact_1.h)("li", { class: "footer-links__item", key: item.id },
                                (0, preact_1.h)("a", { class: "footer-links__link", href: item.url }, item.title))); }))),
                    (0, preact_1.h)("div", { class: "footer-links" },
                        (0, preact_1.h)("p", { class: "footer-links__header" }, "CONNECT"),
                        (0, preact_1.h)("ul", { class: "footer-links__list" }, links &&
                            links.connect.items.map(function (item) { return ((0, preact_1.h)("li", { class: "footer-links__item", key: item.id },
                                (0, preact_1.h)("a", { class: "footer-links__link", href: item.url }, item.title))); }))))),
            (0, preact_1.h)("div", { class: "footer-logo-copyright-disclaimer" },
                (0, preact_1.h)("img", { alt: "O Positiv logo", class: "footer__logo", src: "https://cdn.shopify.com/s/files/1/0588/9340/2261/files/Layer_1.svg?v=1746129256" }),
                (0, preact_1.h)("div", { class: "footer-copyright-disclaimer" },
                    (0, preact_1.h)("div", { class: "footer__copyright" },
                        "COPYRIGHT \u00A9",
                        new Date().getFullYear(),
                        " O POSITIV, INC."),
                    (0, preact_1.h)("div", { class: "footer__disclaimer" }, "*These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure or prevent any disease. The views and nutritional advice expressed by FLO and O POSITIV, Inc. are not intended to be a substitute for conventional medical service. Individual result may vary.")))),
        !excludedUrl && ((0, preact_1.h)(SignupContext_1.SignupContext.Provider, { value: {
                modalOpen: modalOpen,
                setModalOpen: setModalOpen,
                formStep: formStep,
                setFormStep: setFormStep,
                miniPopupOpen: miniPopupOpen,
                setMiniPopupOpen: setMiniPopupOpen,
            } },
            (0, preact_1.h)(Signup_1.default, null)))));
};
exports.default = Footer;
